import './TranscriptLines.css';

export default function TranscriptLines({ transcript, emptyMessage = 'Conversation will appear here…' }) {
  if (!transcript || transcript.length === 0) {
    return <p className="transcript-empty">{emptyMessage}</p>;
  }

  return transcript.map((entry, i) => {
    const isLast = i === transcript.length - 1;
    const isSecondLast = i === transcript.length - 2;
    const fadeClass = isLast ? 'current' : isSecondLast ? 'recent' : 'faded';

    return (
      <p
        key={i}
        className={`transcript-line ${fadeClass}${!entry.final && isLast ? ' streaming' : ''}`}
      >
        {entry.text}
      </p>
    );
  });
}
